import React from 'react';
import { useForm } from 'react-hook-form';
import { Modal, ModalBody, ModalHeader, Col, Row, ModalFooter, Form } from 'reactstrap';
import Button, { ButtonSizes, ButtonVariants } from '@/components/Button/Button';
import FormInput from '@/components/forms/FormInput';
import { AgentDealUpdateRequestsFilterLocal } from '../agent-deal-update-requests-query-reducer';

interface AgentDealUpdateRequestsFilterFormProps {
  onClose: () => void;
  onApplyFilters: (filters: AgentDealUpdateRequestsFilterLocal) => void;
  currentFilters?: AgentDealUpdateRequestsFilterLocal;
}

/**
 * Filter modal for Agent Deal Update Requests page
 * Allows filtering by status, user ID, and agent deal ID
 */
const AgentDealUpdateRequestsFilterForm: React.FC<AgentDealUpdateRequestsFilterFormProps> = ({
  onClose,
  onApplyFilters,
  currentFilters,
}) => {
  const { control, handleSubmit } = useForm({
    defaultValues: {
      applied: currentFilters?.applied !== undefined ? currentFilters.applied : false,
    },
  });

  const onSubmit = (data: any) => {
    // Convert string booleans to actual booleans
    const normalizedData = {
      ...data,
      applied: data.applied === '' ? '' : data.applied === 'true',
    };

    // Clean up empty values
    const cleanedFilters = Object.entries(normalizedData).reduce((acc, [key, value]) => {
      if (value !== undefined && value !== '') {
        acc[key] = value;
      }
      return acc;
    }, {} as AgentDealUpdateRequestsFilterLocal);

    onApplyFilters(cleanedFilters);
  };

  return (
    <Modal centered isOpen>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <ModalHeader toggle={onClose} className="d-flex justify-content-between align-items-center w-full">
          Agent Deal Update Request Filters
        </ModalHeader>
        <ModalBody>
          <Row className="g-3">
            <Col xs={12}>
              <FormInput
                label="Status"
                name="applied"
                control={control}
                type="select"
                options={[
                  { label: 'All', value: '' },
                  { label: 'Pending', value: 'false' },
                  { label: 'Applied', value: 'true' },
                ]}
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button
            className="btn btn-outline"
            variant={ButtonVariants.secondary}
            size={ButtonSizes.sm}
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            className="btn btn-primary"
            variant={ButtonVariants.primary}
            size={ButtonSizes.sm}
            onClick={handleSubmit(onSubmit)}
          >
            Apply Filters
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default AgentDealUpdateRequestsFilterForm;
